import { navOptions } from '@/list/list-selectors';
import { HorizontalScroller } from '@/utils/horizontal-scroller';
import { ArrowLeft, ArrowRight } from '@rsuite/icons';
import * as Sentry from '@sentry/browser';
import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonGroup, IconButton, Nav } from 'rsuite';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;

  .rs-nav {
    margin: auto;
    width: calc(100% - 100px);

    ul {
      overflow-x: auto;
      display: flex;
      flex-direction: row;
      gap: 15px;
    }
  }

  /* changes text color for all tabs */
  /* .rs-nav-item-active > .rs-nav-item-content:hover,
  .rs-nav-item-active > .rs-nav-item-content, */
  .rs-nav-item-content:hover,
  .rs-nav-item-content {
    color: #101938;
  }

  /* affects/changes width of active tab marker, and removes left side space next to first item */
  .rs-nav-item-content {
    padding: 0 0 6px 0;
  }

  .rs-nav-item-active > .rs-nav-item-content {
    color: #37a3bc !important;

    ::before {
      background-color: #37a3bc !important;
    }
  }

  .rs-nav-item {
    margin: 15px 0;

    a {
      padding: 5px;
    }
  }

  /* removes white divider/line underneath the component */
  .rs-nav-waterline {
    display: none;
  }
`;

const ListLRScrollButtons = styled.div`
  display: flex;
  width: auto;
  margin: auto;
`;

// valid grid scroll directions
const SCROLL_DIRECTIONS = {
  right: 'right',
  left: 'left',
};

/**
 * Called the first time user interacts with scroll button
 * @param {Dispatch<React.SetStateAction} setScroller updates hScroller
 */
const createScroller = (setScroller) => {
  // grab scroll container from ag grid
  const scrollableElement = document.querySelector('.ag-center-cols-viewport');
  // init scroller
  const gridScroller = new HorizontalScroller(scrollableElement);
  // registers event listeners
  gridScroller.start();
  // update scroller in state
  setScroller(gridScroller);
  // Needs to be used immediately so return it
  return gridScroller;
};

export function ListViewerNav(props) {
  const navOptionsList = useSelector(navOptions);

  // Too many props to extract all. These are better destructured bc they are hook arguments
  const handleScrollRequest = (direction) => {
    try {
      // If the horizontal scroller exists, use it, else create it then use it
      const scroller =
        props.horizontalScroller || createScroller(props.setHorizontalScroller);
      // var[foo]() is awkward, using IIFE for clarity
      (function performScrollRequest() {
        scroller[direction]();
      })();
    } catch (err) {
      // record scroll exceptions but do not display error message
      Sentry.captureException(err);
    }
  };

  return (
    <Wrapper>
      <Nav
        appearance="subtle"
        activeKey={props.activeNav}
        data-cy="list-view-nav-options-list"
      >
        {navOptionsList.map((navOption) => (
          <Nav.Item
            active={props.activeNav === navOption.eventKey}
            data-testid={`list-view-nav-${navOption.eventKey}`}
            key={navOption.eventKey}
            eventKey={navOption.eventKey}
            onSelect={() => props.onNavClick(navOption)}
          >
            {navOption.label}
          </Nav.Item>
        ))}
      </Nav>

      <ListLRScrollButtons>
        <ButtonGroup>
          <IconButton
            icon={<ArrowLeft />}
            placement="right"
            onClick={() => handleScrollRequest(SCROLL_DIRECTIONS.left)}
          />
          <IconButton
            icon={<ArrowRight />}
            placement="right"
            onClick={() => handleScrollRequest(SCROLL_DIRECTIONS.right)}
          />
        </ButtonGroup>
      </ListLRScrollButtons>
    </Wrapper>
  );
}
